import { Routes } from '@angular/router';

const title = 'Configurración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [

   {
    path: 'formulario',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Formularios' }] },
        loadComponent: () => import('./pages/formulario-lista/formulario-lista.component'),
      },
    
    ],
  },

  
];
